import { lazy } from "react";

// Screens
const SignIn = lazy(() => import("./screens/SignIn.js"));
const Auth = lazy(() => import("./screens/Auth.js"));
const ForgotPassword = lazy(() => import("./screens/ForgotPassword.js"));
const ResetPassword = lazy(() => import("./screens/ResetPassword.js"));
const SignUp = lazy(() => import("./screens/SignUp.js"));
const InvitedSignUp = lazy(() => import("./screens/InvitedSignUp.js"));
const Home = lazy(() => import("./screens/Home.js"));
const Users = lazy(() => import("./screens/Users.js"));
const InteractiveMap = lazy(() => import("./screens/Map.js"));
const ProductsOverview = lazy(() => import("./screens/Products.js"));
const TableView = lazy(() => import("./screens/DataView.js"));
const LcaMag = lazy(() => import("./screens/Magnet.js"));
const Efsa = lazy(() => import("./screens/Efsa.js"));
const Disasters = lazy(() => import("./screens/Disasters.js"));
const Ews = lazy(() => import("./screens/Ews.js"));
const FaostatMap = lazy(() => import("./screens/FaostatMap.js"));
const AiAssistant = lazy(() => import("./screens/AiAssistant.js"));
const Privacy = lazy(() => import("./screens/Privacy.js"));
const Terms = lazy(() => import("./screens/Terms.js"));
const NotFound = lazy(() => import("./screens/NotFound.js"));

// Living Labs
const AIDEMEC = lazy(() => import("./screens-lls/Aidemec.js"));
const CONCATLL = lazy(() => import("./screens-lls/Concatll.js"));
const EcoReadyMasuria = lazy(() => import("./screens-lls/EcoReadyMasuria.js"));
const EcoVitaLl = lazy(() => import("./screens-lls/EcoVitaLl.js"));
const Esappin = lazy(() => import("./screens-lls/Esappin.js"));
const LivOrganic = lazy(() => import("./screens-lls/LivOrganic.js"));
const LOFS = lazy(() => import("./screens-lls/Lofs.js"));
const Probio = lazy(() => import("./screens-lls/Probio.js"));
const SecoCollab = lazy(() => import("./screens-lls/SecoCollab.js"));
const THALLA = lazy(() => import("./screens-lls/Thalla.js"));

// Examples
const BrokerExample = lazy(() => import("./components/Broker.js"));

export const routes = [
	{ index: true, element: SignIn, guestOnly: true },
	{ path: "auth", element: Auth, guestOnly: true },
	{ path: "forgot-password", element: ForgotPassword, guestOnly: true },
	{ path: "reset-password", element: ResetPassword, guestOnly: true },
	{ path: "sign-up", element: SignUp, guestOnly: true },
	{ path: "register", element: InvitedSignUp, guestOnly: true },
	// Public: reachable signed in and signed out
	{ path: "privacy", element: Privacy },
	{ path: "terms", element: Terms },
	{ path: "home", element: Home, protected: true },
	{ path: "users", element: Users, protected: true },
	{ path: "map", element: InteractiveMap, protected: true },
	{ path: "products/:product?", element: ProductsOverview, protected: true },
	{ path: "dataview", element: TableView, protected: true },
	{ path: "socialimpact", element: LcaMag, protected: true },
	{ path: "contaminants", element: Efsa, protected: true },
	{ path: "disasters", element: Disasters, protected: true },
	{ path: "ews", element: Ews, protected: true },
	{ path: "faostat", element: FaostatMap, protected: true },
	{ path: "aiassistant", element: AiAssistant, protected: true },
	// Living Labs
	{ path: "aidemec/:tab?", element: AIDEMEC, protected: true },
	{ path: "concatll/:tab?", element: CONCATLL, protected: true },
	{ path: "ecoreadymasuria/:tab?", element: EcoReadyMasuria, protected: true },
	{ path: "ecovitall/:tab?", element: EcoVitaLl, protected: true },
	{ path: "esappin/:tab?", element: Esappin, protected: true },
	{ path: "livorganic/:tab?", element: LivOrganic, protected: true },
	{ path: "lofs/:tab?", element: LOFS, protected: true },
	{ path: "probio/:tab?", element: Probio, protected: true },
	{ path: "secocollab/:tab?", element: SecoCollab, protected: true },
	{ path: "thalla/:tab?", element: THALLA, protected: true },
	// Examples
	{ path: "broker", element: BrokerExample, protected: true },
	{ path: "*", element: NotFound },
];
